export default __webpack_public_path__ + "static/media/nyan-cat.f1fff8cc.svg";